import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getPricingTierList(pageNumber = 1, filterQuery, pagination = defaultPagination, is_paginate = 0) {
    return Repository.get(`/admin/system_setting/customer/pricing-tiers?paginate=${pagination}&page=${pageNumber}&${filterQuery}&is_paginate=${is_paginate}`)
  },
  updatePricingTier(payload) {
    return Repository.post(`/admin/system_setting/customer/pricing-tiers`, payload)
  },
  deleteCcp(id) {
    return Repository.delete(`${resource}/ccp_items/${id}`)
  },
  updateCcp(id, payload) {
    return Repository.put(`${resource}/ccp_items/${id}`, payload)
  }
};
